module.exports = __webpack_public_path__ + "static/ch5-SCENE-07-Marching_For_The_Vote-43f420e3343dce3b26de78dfaf2abc34.mp4";